import React from 'react'
import createReactClass from 'create-react-class'
import ConfirmationPanel from './modal-panels/confirmation-modal-panel'

export default createReactClass({
  getInitialState () {
    return {
      showModal: false,
    }
  },
  openModal () {
    this.setState({
      showModal: true,
    })
  },
  closeModal () {
    this.setState({
      showModal: false,
    }, () => {
      this.props.onModalClose()
    })
  },
  renderModalPanel () {
    if (this.state.showModal) {
      return (
        <ConfirmationPanel {...this.props} closeModal={this.closeModal} />
      )
    }
    return false
  },
  render () {
    return (
      <span>
        <button type='button' onClick={this.openModal} className="cs-primary-button"
          disabled={this.props.isDisabled}>Delete</button>
        {this.renderModalPanel()}
      </span>
    )
  },

  componentWillReceiveProps (nextProps) {
    if (nextProps.isSuccess) {
      this.closeModal()
    }
  },
})



// WEBPACK FOOTER //
// ./src/components/confirmation-panel.js